import zlcBackGroundImage from "../assets/images/zlcBackground.png";

export let appParamater = {
  name: "qmeter",
  font: "Qmeter",
  backgroundImage: null,
};

const companyIds = {
  69: "zlc", // dash => zlc,
  // 246: "zlc" // appnew => zlc,
  // 226: // appnew =>  nazar,
  259: "ibar", // appnew => chuxani
};

const designs = {
  ibar: {
    name: "ibar",
    font: "Qmeter",
    backgroundImage: null,
  },
  zlc: {
    name: "zlc",
    font: "Zlc",
    backgroundImage: zlcBackGroundImage,
  },
};

export const setAppParameter = (id) => {
  const companyName = companyIds[id];
  if (companyName) {
    appParamater = designs[companyName];
    const root = document.querySelector(":root");
    root.style.setProperty("--font-face", appParamater.font);
  }
};
